import type { MatchesFiltersComponent } from "@motain/xpa-proto-files-web/lib/types/matches_filters_component";
import { MatchTypes } from "@/xpa-components/match-types-filters/match-types/MatchTypes";
import { isNonNullable } from "@/types/isNonNullable";
import { DatePickerWrapper } from "@/xpa-components/date-picker/date-picker-wrapper/DatePickerWrapper";
import { Title } from "@/xpa-components/title/Title";
import type { FC } from "react";

import styles from "./MatchTypesFilters.module.scss";
import classNames from "classnames";

export const MatchTypesFilters: FC<MatchesFiltersComponent> = (props) => {
  const { datePicker, matchTypes } = props;

  const hasDatePicker = isNonNullable(datePicker);

  const hasMatchTypesFilter = isNonNullable(matchTypes);

  const isMissingComponent = !hasDatePicker || !hasMatchTypesFilter;

  return (
    <div
      className={classNames(
        styles.container,
        isMissingComponent && styles.missingComponent,
      )}
    >
      {hasDatePicker && <DatePickerWrapper {...datePicker} />}
      {hasMatchTypesFilter && isNonNullable(matchTypes.label) && (
        <>
          <hr className={styles.divider}></hr>
          <div className={styles.matchTypesWrapper}>
            <Title
              {...matchTypes.label}
              className={classNames("screen-reader-only", styles.title)}
            />
            <MatchTypes {...matchTypes} />
          </div>
        </>
      )}
    </div>
  );
};
